import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { JumplinksTitleProps } from "../typings";

const JumplinksTitle = (props: JumplinksTitleProps) => {
  const { model, context } = props;
  const { title } = model;
  const { location } = context.searchContext;
  const locationName = location.localizedName || location.defaultName || location.name;

  if (!(title || locationName)) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <h3 className="uitk-type-heading-500 all-b-margin-two">
      {title || formatText("jumplinks.discover", locationName)}
    </h3>
  );
};

export default JumplinksTitle;
